var exports = {
  "zr": "AudioWaveform.module__root___QlBZal",
  "Ji": "AudioWaveform.module__canvas___QlBZal",
  "r1": "AudioWaveform.module__selection___QlBZal",
  "EP": "AudioWaveform.module__selectionDragging___QlBZal",
  "p$": "AudioWaveform.module__handle___QlBZal",
  "p_": "AudioWaveform.module__handleStart___QlBZal",
  "es": "AudioWaveform.module__handleEnd___QlBZal",
  "lG": "AudioWaveform.module__playhead___QlBZal",
};

module.exports = exports;
